import { PageName, useApp } from '@/App';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';
import { Card, Flex, List } from 'antd';
import { FC } from 'react';
import CountUp from 'react-countup';

const FCASThingsTodo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	return (
		<List
			loading={isLoading}
			grid={{ gutter: 20, column: 2 }}
			dataSource={[
				{
					title: 'Pencetakan Dokumen Pencairan',
					count: counts?.disbursementPrinting ?? 0,
					link: 'DisbursementListPage',
				},
			]}
			renderItem={(item) => {
				return (
					<List.Item style={{ marginBottom: 20 }}>
						<Card
							hoverable
							size="small"
							style={{ borderRadius: 0 }}
							onClick={() => {
								navigate(item.link as PageName);
							}}
						>
							<Flex
								justify="space-between"
								align="center"
							>
								{item.title}
								<div
									className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
								>
									<CountUp end={item.count} />
								</div>
							</Flex>
						</Card>
					</List.Item>
				);
			}}
		/>
	);
};

export default FCASThingsTodo;
